import React, { FC, MutableRefObject } from 'react';
import { makeStyles } from 'tss-react/mui';

import FastCatIcon from '@mui/icons-material/FlashOn';
import MUISplitIcon from '@mui/icons-material/CallSplit';

import { transactionsUtils, transactionsTypes } from 'companion-app-components/flux/transactions';

import QIconButton from 'components/QIconButton';

import { isUncategorizedTxn } from 'data/transactions/utils';
import { getFieldString } from 'data/transactions/searchFilter';

import { RegListItem, styles } from '../styles';

import type { AttributesType, CallbacksType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface SplitFieldProps {
  attributes: AttributesType;
  forceStatic: boolean;
  callbacks: CallbacksType;
  editable: boolean;
  SHOW_ALL: boolean;
  fieldActive: boolean;
  txn: transactionsTypes.CashFlowTransaction;
  payeeCategoryMap: Record<string, any>;
  suggestCategoryForUncategorized: boolean;
  focusField: MutableRefObject<HTMLAnchorElement | null>;
}

const SplitField: FC<SplitFieldProps> = ({
  attributes,
  forceStatic,
  callbacks,
  editable,
  SHOW_ALL,
  fieldActive,
  txn,
  payeeCategoryMap,
  suggestCategoryForUncategorized,
  focusField,
}) => {
  const { classes } = useStyles();

  let suggestTxn = null;
  if (isUncategorizedTxn(txn) && suggestCategoryForUncategorized) {
    const suggestRecord =
      txn.payee && payeeCategoryMap ? payeeCategoryMap.get(txn.payee?.toLowerCase()) : null;
    if (suggestRecord && !transactionsUtils.isSplitTxn(suggestRecord.txn) && !isUncategorizedTxn(suggestRecord.txn)) {
      suggestTxn = suggestRecord.txn;
    }
  }

  return (
    <RegListItem
      {...attributes}
      tabIndex={null}
      className={classes.iconColumn}
      onClick={null}
    >
      {SHOW_ALL && !forceStatic &&
      <>
        {(transactionsUtils.isSplitTxn(txn) || editable) &&
        <QIconButton
          aria-label="Split Transaction"
          autoFocus={fieldActive}
          ref={fieldActive ? (input) => {
            focusField.current = input; // eslint-disable-line
          } : null}
          focusRipple
          IconComponent={MUISplitIcon}
          onClick={() => callbacks.regFieldClick?.('split', txn)}
          size="small-target"
          TooltipProps={{ enterDelay: 10 }}
        />}

        {!editable && suggestTxn &&
        <QIconButton
          aria-label="Fast Categorize"
          autoFocus={fieldActive}
          disabled={forceStatic}
          focusRipple
          ref={fieldActive ? (input) => {
            focusField.current = input; // eslint-disable-line
          } : null}
          IconComponent={FastCatIcon}
          onClick={(!txn.split && forceStatic) ? null : () =>
            callbacks.regFieldClick?.('categorySuggest', txn, suggestTxn)}
          size="small-target"
          tooltip={`Click to fast categorize as ${getFieldString('category', suggestTxn)}`}
          TooltipProps={{ enterDelay: 10 }}
        />}
      </>}
    </RegListItem>
  );
};

export default SplitField;
